import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ imageUrl, logoClass }) => {
  return (
    <div className={`${logoClass ? logoClass : ""}`} style={{ marginTop: '8px'}}>
      {global.aziendaID == 1 ? <Link to={process.env.PUBLIC_URL + "/"}>
        <img alt="" src={imageUrl}  style={{width:"100px"}}/>
      </Link> : <img alt="" src={imageUrl}  style={{width:"100px"}}/>}
    </div>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string
};

export default Logo;
